"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DefaultIcon_1 = __importDefault(require("./icons/DefaultIcon"));
const Button_1 = __importDefault(require("./Button"));
const IconType_1 = __importDefault(require("./enums/IconType"));
const ColorType_1 = __importDefault(require("./enums/ColorType"));
const react_2 = require("react");
const TextInput = (props) => {
    const [showPassword, setShowPassword] = (0, react_2.useState)(false);
    var inputClass;
    switch (props.state) {
        case "normal":
            inputClass = "textinput__input--default";
            break;
        case "error":
            inputClass = "textinput__input--default textinput__input--error";
            break;
    }
    return (react_1.default.createElement("div", { className: "textinput" },
        react_1.default.createElement("label", { className: "textinput__label", htmlFor: props.name }, props.label),
        react_1.default.createElement("div", { className: "textinput__input-container" },
            react_1.default.createElement("input", { className: props.value.length !== 0
                    ? inputClass + " textinput__input--has-button"
                    : inputClass, name: props.name, type: props.type === "password" && showPassword === true
                    ? "text"
                    : props.type, id: props.name, required: props.isRequired, onChange: (e) => props.onChangeHandler(e.target.value), value: props.value, placeholder: props.placeholder }),
            react_1.default.createElement("div", { className: "textinput__aux" },
                react_1.default.createElement("p", { className: "textinput__unit" }, props.unit),
                react_1.default.createElement("div", { className: props.value.length !== 0 && props.unit.length !== 0
                        ? "textinput__button--visible textinput__aux-divider"
                        : "textinput__button--hidden textinput__aux-divider" }),
                react_1.default.createElement("div", { className: props.value.length !== 0
                        ? "textinput__button--visible"
                        : "textinput__button--hidden" }, props.type === "password" ? (react_1.default.createElement(Button_1.default, { state: "enabled", type: "input", label: "", icon: showPassword === false
                        ? IconType_1.default.Show
                        : IconType_1.default.Hide, handlerFunction: () => setShowPassword(!showPassword) })) : (react_1.default.createElement(Button_1.default, { type: "input", state: "enabled", label: "", icon: IconType_1.default.Cancel, handlerFunction: () => props.onChangeHandler("") }))))),
        props.state === "error" ? (react_1.default.createElement("div", { className: "textinput__error" },
            react_1.default.createElement(DefaultIcon_1.default, { type: IconType_1.default.Error, color: ColorType_1.default.Red, size: "12" }),
            react_1.default.createElement("p", { className: "textinput__errortext" }, props.errorText))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.default = TextInput;
